import styled from '@emotion/styled';
import { space } from 'styled-system';
import { StyledProps as Props, Theme } from './Menu.types';
import css from '@styled-system/css';

export default styled.ul<Props, Theme>`
  ${space}
  ${css({
    height: '100%',
    width: '100%',
    bg: 'var(--color-extra-white)',
    zIndex: '0',
    listStyle: 'none',
  })}
`;
